import { render, staticRenderFns } from "./InteractionOfElementBackgroundColor.vue?vue&type=template&id=88b901e6&scoped=true&"
import script from "./InteractionOfElementBackgroundColor.vue?vue&type=script&lang=js&"
export * from "./InteractionOfElementBackgroundColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b901e6",
  null
  
)

export default component.exports